import { useTheme } from '@mui/material/styles';
import { useAtom } from "jotai";
import { selectedInsightRowAtom } from "../../stores/jotai/insights/selectedInsightRow";
import useSwitchTeam from "./hooks/useSwitchTeam";
import { TeamsDropdown } from "./teams-dropdown";

export default function TeamDropdownBridge(props: any) {
    const { switchTeam } = useSwitchTeam();
    const [selectedInsightRow, setSelectedInsightRow] = useAtom(
        selectedInsightRowAtom
    );
    const theme = useTheme();
    return (
        <TeamsDropdown
            echoOpen={(open) => {
                if (props.echoOpen) {
                    props.echoOpen(open);
                }
            }}
            {...props}
            handleSwitchTeams={switchTeam}
            setSelectedInsightRow={setSelectedInsightRow}
            theme={theme}
        />
    );
}
